import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectMode } from "../../redux/selectors/editor";
import { updateHelpAvailable } from "../../redux/slices/editor";
import MuiMarkdown from 'mui-markdown';
import HelpDialog from "./HelpDialog";
import {remoteFileExists} from "../../utility/url";

type Props = {
    mode: string
    onClose: () => void
    open: boolean
    updateHelpAvailable: (available: boolean) => void
};

function Help({mode, onClose, open, updateHelpAvailable}: Props)
{
    const [markdown, setMarkdown] = useState<string>("");
    const overrides = {
        ul: {
            component: Typography,
            props: {
                variant: "body2"
            }
        }
    };

    useEffect(() => {
        const server = "https://content.flavourworks.co";
        const folder = "pathway/help";
        const path = `${server}/${folder}/${mode || "projects"}.md?${Date.now()}`;

        remoteFileExists(path).then(exists => {
                exists && fetch(path).then(response => {
                    if (response.ok) {
                        response.text().then(text => {
                            setMarkdown(text);
                            updateHelpAvailable(true);
                        });
                    } else {
                        setMarkdown(`Error fetching content from ${path} (${response.status})\n`);
                        updateHelpAvailable(false);
                    }
                });
            }
        );
    }, [mode, setMarkdown, updateHelpAvailable]);
    return (
        <HelpDialog onClose={onClose} open={open}>
            <MuiMarkdown children={markdown} overrides={overrides}/>
        </HelpDialog>
    );
}

const mapStateToProps = (store: never) => ({
    mode: selectMode(store)
});

export default connect(mapStateToProps, {
    updateHelpAvailable
})(Help);